export default {
  opensave: {
    new_doc: 'Nowy obraz',
    open_image_doc: 'Otwórz SVG',
    save_doc: 'Zapisz SVG',
    save_as_doc: 'Zapisz jako SVG'
  }
}